module.exports = __webpack_public_path__ + "img/csr_swiper_04_01.f525fcf0.jpg";